import React, { useState, useEffect, useCallback } from 'react';

import { colors } from '../../../theme';
import { api } from '../../../services/api';
import { Checkbox, Button, Loader } from '../../../components';

import { Container } from './styles';

const StudBook = ({ id }) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [animalIsBlocked, setAnimalIsBlocked] = useState(false);

  useEffect(() => {
    setLoading(true);

    async function fetchStatusStudBook() {
      try {
        const { data } = await api.get('animal/perfil', {
          params: {
            id_animal: id,
          },
        });

        if (data.success) {
          setAnimalIsBlocked(data.data[0].status_studbook === 0 ? true : false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchStatusStudBook();
  }, [id]);

  const handleStatus = useCallback(async () => {
    setAnimalIsBlocked(!animalIsBlocked);
    setChecked(false);

    try {
      await api.post('animal/statusanimalstudbookupdate', {
        id_animal: id,
        block_studbook: animalIsBlocked ? 0 : 1,
      });
    } catch (error) {
      console.log(error);
    }
  }, [animalIsBlocked, id]);

  if (loading) {
    return <Loader light />;
  } else {
    return (
      <Container>
        {animalIsBlocked ? (
          <>
            <h1>
              Este animal está <strong>BLOQUEADO</strong> no Stud Book
            </h1>

            <p>
              Deseja reativar este Animal no Stud Book? <br />
              Esta ação reativará o animal para futuras transferências.
            </p>
          </>
        ) : (
          <>
            <h1>
              Este animal está <strong>ATIVO</strong> no Stud Book
            </h1>

            <p>
              Deseja bloquear este Animal no Stud Book? <br />
              Esta ação bloqueará o animal para futuras transferências.
            </p>
          </>
        )}

        <div className="checkbox-button-wrapper">
          <Checkbox
            light
            checked={checked}
            onChange={(valueChecked) => setChecked(valueChecked)}
          >
            {animalIsBlocked
              ? 'Sim, reativar este animal.'
              : 'Sim, bloquear este animal.'}
          </Checkbox>

          <Button
            width={112}
            height={32}
            color={colors.lightGreen}
            disabled={!checked}
            bgDark
            fontLight
            onClick={handleStatus}
          >
            {animalIsBlocked ? 'Reativar' : 'Bloquear'}
          </Button>
        </div>
      </Container>
    );
  }
};

export default StudBook;
